import { ServicesWrapper } from './style';
import useMediaQuery from '@mui/material/useMediaQuery';

// Component
import Text from 'components/common/Text';
import Image from 'next/image';
import Container from 'components/common/Layout/Container';

// Libs
import Translation from 'libs/Translation';

const Services = ({ webConfig }) => {
    const isMobile = useMediaQuery('(max-width:900px)');

    return (
        <Container>
            <ServicesWrapper>
            <Text
                tag="h2"
                className="title"
            >
                {Translation.t('title.vclinic-services-for-doctors')}
            </Text>
            <Image
                alt="vclinic-health-provider-panel"
                src="/nextasset/images/home/panel.svg"
                width={720}
                height={500}
            />
            {!isMobile
            ?
            <Image
                alt="vclinic-services"
                src={webConfig.lang === 'fa' ? "/nextasset/images/home/services.png" : "/nextasset/images/home/services-en.png"}
                width={1220}
                height={webConfig.lang === 'fa' ? 240 : 255}
            />
            :
            <Image
                alt="vclinic-services"
                src={webConfig.lang === 'fa' ? "/nextasset/images/home/services-m.png" : "/nextasset/images/home/services-m-en.png"}
                width={300}
                height={570}
            />
            }
            </ServicesWrapper>
        </Container>
    )
}
export default Services;